import React from "react";

// Components
import { IonNote } from "@ionic/react";
import InputFactory from "../Factories/Input/InputFactory";

// Styles
import ModalConfirmation from "./ModalConfirmation";
import "./Modals.scss";

export default class ModalFieldForm extends React.Component<any, any> {
  render() {
    const { isOpen, classModifiers, field, buttons, user } = this.props;
    const { key, name, scope, type, ...fieldProps } = field || {};
    const error = this.props.errors?.[`${scope}.${key}`]?.[0] || this.props.error;

    return (
      <ModalConfirmation isOpen={isOpen} closeModal={this.props.closeModal} classModifiers={classModifiers} heading={this.props.heading} type={this.props?.type} buttons={buttons}>
        <label className="modal-field-form__label">{name}</label>
        <div className={`input__container input__container--type-${type} ${error && "has-error"}`}>
          <InputFactory
            name={key}
            placeholder={name}
            type={type}
            className="input__input modal-field-form__input"
            {...fieldProps}
            onIonChange={this.handleInputChange}
            onIonChangeSupporting={this.handleSupportingInputChange}
            error={error}
            user={user}
          />
          {error && <IonNote color="danger">{error}</IonNote>}
        </div>
      </ModalConfirmation>
    );
  }

  handleInputChange = (e: any) => {
    const field = this.props.field;
    field.value = e.detail.hasOwnProperty("value") ? e.detail.value : e.target.value;
    this.setState({ field });
  };

  handleSupportingInputChange = (e: any) => {
    const field = this.props.field;
    if (!field.supportingValues) {
      field.supportingValues = [];
    }
    field.supportingValues[e.target.name] = e.target.value;
    this.setState({ field });
  };
}
